import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { getCompanyByCompanyId } from '../utilities/common-company';

const CustomerPageContext = createContext(null);

export function CustomerPageProvider({ user, openCompanyNag, setOpenCompanyNag, children }) {
    const [company, setCompany] = useState(null);
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [loading, setLoading] = useState(false);
    const [serviceIsDown, setServiceIsDown] = useState(false);

    const loadCompany = async () => {
        if (!user?.companyId) {
            setCompany(null);
            setSelectedTenant(null);
            return;
        }

        setLoading(true);
        try {
            const result = await getCompanyByCompanyId(user.companyId, setServiceIsDown);
            setCompany(result || null);
            const tenants = result?.tenantList || [];
            setSelectedTenant(tenants.find(tenant => Number(tenant.id) === Number(user.tenantId)) || tenants[0] || null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadCompany();
    }, [user?.companyId, user?.tenantId]);

    const value = useMemo(() => ({
        company,
        selectedTenant,
        setSelectedTenant,
        loading,
        serviceIsDown,
        refreshCompany: loadCompany,
        openCompanyNag,
        setOpenCompanyNag,
    }), [company, selectedTenant, loading, serviceIsDown, openCompanyNag, setOpenCompanyNag]);

    return <CustomerPageContext.Provider value={value}>{children}</CustomerPageContext.Provider>;
}

export function useCustomerPageContext() {
    return useContext(CustomerPageContext) || {};
}
